import { ToastMessage } from './../../providers/toast-message';
import { ApiV1 } from './../../providers/api-v1';
import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the DebugPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@Component({
  selector: 'page-debug',
  templateUrl: 'debug.html',
})
export class DebugPage {

  constructor(public navCtrl: NavController, public navParams: NavParams, public apiV1: ApiV1, public toastMsg: ToastMessage) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad DebugPage');
  }


  toastMessage() {
    this.toastMsg.message("toastMsg message");
  }

  toastSuccess() {
    this.toastMsg.success("toastMsg success");
  }

  toastError() {
    this.toastMsg.error("toastMsg error");
  }

  writeLog() {
    this.apiV1.writeLog("myDevice", "myCloud", "myComment");
  }

  testAzure() {
    // this.serverProvider.testAzure();
  }

  hello() {
    this.apiV1.hello();
  }

}



// WEBPACK FOOTER //
// ./src/pages/debug/debug.ts